import { useMemo } from 'react';

import { useSuspenseGetApplication } from '../../../api/lending/lapiHooks.suspense';
import { getIwocaPayApplication } from '../Dashboard.helpers';

export function useIwocaPayApplication() {
  const { application } = useSuspenseGetApplication();

  return useMemo(
    () => (application ? getIwocaPayApplication(application) : null),
    [application],
  );
}
